import React, { Component } from 'react'
import ReactDOM from "react-dom";
import queryString from 'query-string';
import moment from 'moment';
import momentTimeZone from 'moment-timezone';
import { APPLICATION_JSON } from '../middleware/types';

let vastfmsErrorUiLabels;
let storefrontUiLabels;
let assocProducts;
const encoderValues = new Map();
encoderValues.set('/', '~2F');
encoderValues.set(' ', '+');
encoderValues.set("&", "%26");
encoderValues.set("%", "~25");

export default {

    // // Save data to sessionStorage
    // sessionSetItem: (key, value) => {
    //     sessionStorage.setItem(key, value);
    // },
    // // Get saved data from sessionStorage
    // sessionGetItem: (key) => {
    //     let data = sessionStorage.getItem(key);
    //     return data
    // },

    // // Remove saved data from sessionStorage
    // sessionRemoveItem: (key) => {
    //     let data = sessionStorage.removeItem(key);
    //     return data
    // },

    // // Remove all saved data from sessionStorage
    // sessionClearAllItem: () => {
    //     sessionStorage.clear();
    // },

    // isNotEmptyObject: (obj) => {
    //     for (var prop in obj) {
    //         if (Object.prototype.hasOwnProperty.call(obj, prop)) {
    //             return true;
    //         }
    //     }
    //     return false;
    // },

    // envUrl: () => {
    //     // return process.env.REACT_APP_API_ENDPOINT;
    //     return `${window.location.protocol}//${window.location.hostname}`;
    // },
    // actionUrl: () => {
    //     return `${window.location.protocol}//${window.location.hostname}`;
    //     // return process.env.REACT_APP_ACTION_API_ENDPOINT;
    // },
    // imgUrl: () => {
    //     return `${window.location.protocol}//${window.location.hostname}/static/images`;
    //     // return process.env.REACT_APP_IMAGE_ENDPOINT;
    // },
    // canSplit: (str, token) => {
    //     return canSplit(str, token);
    // },
    // splitContent: (str, token) => {
    //     return splitContent(str, token);
    // },
    // splitJoin: (str, token, joinToken) => {
    //     return splitJoin(str, token, joinToken);
    // },
    serialize: (form) => {
        return serialize(form);
    },
    // getCartItem: () => {
    //     const cartQty = fetch(`${window.location.protocol}//${window.location.hostname}/get-cart-item`)
    //         .then(response => {
    //             return response.json();
    //         }).then(result => {
    //             console.log("cartQtyHelper" + result);
    //             console.log("cartQtyHelper" + result.cartQty);
    //             return result.cartQty;
    //         });
    // },
    // logout: () => {
    //     const logot = fetch(`${window.location.protocol}//${window.location.hostname}/logout`)
    //         .then(response => {
    //             return response.json();
    //         }).then(result => {
    //             window.location.href = "/"
    //         });
    // },
    // currencyFormatter: (currency) => {
    //     //    return getformattedCurrency(currency);
    //     return Number.parseFloat(currency).toFixed(2);
    // },
    clearErrorMsg: (form) => {
        document.querySelectorAll(`#${form} .error_message`).forEach(elmn => elmn.remove());
    },
    errorMsgClear: (formId) => {
        document.querySelectorAll(`#${formId} .error`).forEach((elem) => {
            elem.innerHTML = '';
        })
    },
    // appendMessage: (id, msg, isError) => {
    //     var data = "";
    //     if (isError) {
    //         data = `<p class="error error_message mb-0 mt-2 small-txt-font">${msg}</p>`;
    //     } else {
    //         data = `<p class="mb-0 mt-2 small-txt-font text-green">${msg}</p>`
    //     }
    //     document.getElementById(id).innerHTML = data;
    // },
    // // errorMsgLoader:(json, formId)=>{        

    // //     $.each(json, function(key, data) {
    // //         if (!key.startsWith('org.')) {            
    // //         // console.log(`form = ${form} -- key = ${key} -- Data = ${data}`);

    // //         $(`#${formId} [name="` + key + `"]`).append('div').after('<p class="error_message error mb-3">' + data + '</p>');
    // //         }
    // //     });
    // //     $(`${formId} [type="hidden"]`).next().remove("p.error_message");   
    // // },
    fieldValidation: (fieldPattern, message, name, fieldData, id) => {

        const fieldRegPattern = new RegExp(fieldPattern);
        var elmName = "";
        var errorKeyName = name + '_error';

        if (!(fieldRegPattern.test(fieldData))) {
            elmName = document.querySelector(`[id=${errorKeyName}]`);
            if (elmName) {
                document.getElementById(errorKeyName).innerHTML = '<p class="error mb-1 ' + "" + '">' + message + '</p>'
                return elmName
            }
        }
        else {
            document.getElementById(errorKeyName).innerHTML = ''
        }
    },
    errorMsgLoader: (json, formId, className) => {
        for (var key in json) {
            if (!key.startsWith('org.')) {
                var errorKey = key + '_error'
                if (formId) {
                    //var elmName =  document.querySelector(`#${formId} [name=${key}]`);
                    var elmName = document.querySelector(`#${formId} [id=${errorKey}]`);
                } else {
                    //var elmName =  document.querySelector(`[name=${key}]`);
                    var elmName = document.querySelector(`[id=${errorKey}]`);
                }
                if (elmName) {
                    let node = elmName.parentElement.nodeName;
                    //console.log(elmName.parentElement);   
                    elmName.parentElement.innerHTML += ('<p class="error_message error mb-3 ' + className + '">' + json[key] + '</p>');
                    elmName.innerHTML = json[key]
                }
            }
        }
    },
    isEmpty: (value) => {
        return isEmpty(value);
    },

    // updateURL: (urlParam) => {
    //     var origin = window.location.origin;
    //     var updatedURL = `${origin}${urlParam}`;
    //     window.history.pushState(updatedURL, urlParam, urlParam);
    // },
    // sortingChecks: (param) => {
    //     const parsed = queryString.parse(window.location.search);
    //     var sortBy = parsed.sortBy;
    //     if (sortBy) {
    //         document.querySelector('.select-box .select-box__select option[value="' + sortBy + '"]').attr('selected', 'selected');
    //     }
    // },
    // facetChecks: (param) => {
    //     var location = window.location.pathname;
    //     var encodeLocation = decodeURI(location);
    //     let facetContainerPath = encodeLocation.includes("/-/") ? splitContent(encodeLocation.split('/-/')[1], "+") : '';
    //     var fields = ["br_", "pr_", "pi_", "ca_", "co_", "sp_"];
    //     if (facetContainerPath) {
    //         facetContainerPath.forEach((onePath) => {
    //             var splittedData = splitContent(onePath, "_");
    //             var key = splittedData[0] + "_";
    //             var values = splitContent(splittedData[1], "::");
    //             console.log(values)
    //             console.log("=====================");
    //             if (fields.includes(key) && values) {
    //                 var queryVal = `.facet-list .form-check-input.${key}`;
    //                 console.log(queryVal);
    //                 document.querySelectorAll(queryVal).forEach(function (facet) {
    //                     if (values.find(element => unescape(element.toLowerCase()) == facet.value.toLowerCase())) {
    //                         facet.checked = true;
    //                     } else {
    //                         facet.checked = false;
    //                     }
    //                 });
    //             }
    //         });
    //     }

    //     function hasValue(facet, value) {
    //         return facet == value;
    //     }
    // },
    // replaceProp: (prop, currentProp, replaceProp) => {
    //     return prop.replace(currentProp, replaceProp);
    // },
    // getStorefrontUiLabels: () => {
    //     return storefrontUiLabels;
    // },
    // getVastfmsErrorUiLabels: () => {
    //     return vastfmsErrorUiLabels;
    // },
    // getResourceBundle: (currentLocale) => {
    //     const rb = fetch(`${window.location.protocol}//${window.location.hostname}/get-resource-bundle?locale=${currentLocale}`)
    //         .then(response => {
    //             return response.json();
    //         }).then(result => {
    //             storefrontUiLabels = result.StorefrontUiLabels;
    //             vastfmsErrorUiLabels = result.vastfmsErrorUiLabels;
    //             return result;
    //         });
    // },
    // setResourceBundle: (result) => {
    //     storefrontUiLabels = result.StorefrontUiLabels;
    //     vastfmsErrorUiLabels = result.vastfmsErrorUiLabels;
    //     return;
    // },
    // isEmpty: (value) => {
    //     return checkEmpty(value);
    // },
    // handleValidateTouch(event) {
    //     handleValidation(event)
    // },
    // calculateDiscount: (basePrice, listPrice) => {
    //     var result = ((Number.parseFloat(listPrice) - Number.parseFloat(basePrice)) / Number.parseFloat(listPrice)) * 100;
    //     return Math.round(result);
    // },
    // getAssocProducts: (url, productId) => {
    //     const rb = fetch(`${window.location.protocol}//${window.location.hostname}/${url}?productId=${productId}&format=json`)
    //         .then(response => {
    //             return response.json();
    //         }).then(result => {
    //             return result;
    //         });
    // },
    // getCountries: () => {
    //     fetch(`${window.location.protocol}//${window.location.hostname}/get-countries-list`)
    //         .then(response => {
    //             return response.json();
    //         })
    //         .then(result => {
    //             return result.countries;
    //         })
    // },
    // getAssocStates: (geoId) => {
    //     fetch(`${window.location.protocol}//${window.location.hostname}/get-states-list?geoId=${geoId}`)
    //         .then(response => {
    //             return response.json();
    //         })
    //         .then(result => {
    //             return result.states;
    //         })
    // },
    // displayBlock: (elm) => {
    //     let element = document.querySelector(elm);
    //     if (element) {
    //         ReactDOM.findDOMNode(element).style.display = 'block';
    //     }
    // },
    // displayNone: (elm) => {
    //     let element = document.querySelector(elm);
    //     if (element) {
    //         ReactDOM.findDOMNode(element).style.display = 'none';
    //     }
    // },
    // isMobileDevice: () => {
    //     let check = false;
    //     (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    //     return check
    // },
    // getMonths: () => {
    //     // let months = {
    //     //     "01":"01-Jan",
    //     //     "02":"02-Feb",
    //     //     "03":"03-Mar",
    //     //     "04":"04-Apr",
    //     //     "05":"05-May",
    //     //     "06":"06-June",
    //     //     "07":"07-July",
    //     //     "08":"08-Aug",
    //     //     "08":"09-Sept",
    //     //     "10":"10-Oct",
    //     //     "11":"11-Nov",
    //     //     "12":"12-Dec",

    //     // };
    //     let months = {}
    //     for (let index = 1; index <= 12; index++) {
    //         if (index < 10) {
    //             Object.assign(months, { ["0" + index]: parseInt(`0${index}`) });
    //         } else {
    //             Object.assign(months, { [index]: parseInt(`${index}`) });
    //         }
    //     }
    //     return months;
    // },
    // getYears: () => {
    //     var date = new Date();
    //     var currentYear = date.getFullYear();
    //     var futureYear = currentYear + 50;
    //     let year = {};
    //     Object.assign(year, { "": "" });
    //     for (let index = currentYear; index <= futureYear; index++) {
    //         Object.assign(year, { [index]: index });
    //     }
    //     return year;
    // },
    // detectCardType: (number) => {
    //     var re = {
    //         electron: /^(4026|417500|4405|4508|4844|4913|4917)\d+$/,
    //         maestro: /^(5018|5020|5038|5612|5893|6304|6759|6761|6762|6763|0604|6390)\d+$/,
    //         dankort: /^(5019)\d+$/,
    //         interpayment: /^(636)\d+$/,
    //         unionpay: /^(62|88)\d+$/,
    //         visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
    //         mastercard: /^5[1-5][0-9]{14}$/,
    //         amex: /^3[47][0-9]{13}$/,
    //         diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
    //         discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
    //         jcb: /^(?:2131|1800|35\d{3})\d{11}$/
    //     }

    //     for (var key in re) {
    //         if (re[key].test(number)) {
    //             return key
    //         }
    //     }
    // },
    // sumOfTwoNumbers: (num1, num2) => {
    //     return Number(num1) + Number(num2);
    // },
    // subOfTwoNumbers: (num1, num2) => {
    //     return Number(num1) - Number(num2);
    // },
    // phoneNoFormatter: (number) => {
    //     return (number.slice(0, 2) + " (" + number.slice(2, 5) + ") " + number.slice(5, number.length));
    // },
    // urlPathFormatter: (url) => {
    //     return (url.slice(1, url.length));
    // },
    // updateQueryStringParameter: (uri, key, value) => {
    //     var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
    //     if (value === undefined) {
    //         if (uri.match(re)) {
    //             return uri.replace(re, '$1$2');
    //         } else {
    //             return uri;
    //         }
    //     } else {
    //         if (uri.match(re)) {
    //             return uri.replace(re, '$1' + key + "=" + value + '$2');
    //         } else {
    //             var hash = '';
    //             if (uri.indexOf('#') !== -1) {
    //                 hash = uri.replace(/.*#/, '#');
    //                 uri = uri.replace(/#.*/, '');
    //             }
    //             var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    //             return uri + separator + key + "=" + value + hash;
    //         }
    //     }
    // },
    // buildProductUrl: (productId, productName) => {
    //     var productUrl = `/product/p_${productId}`;
    //     productUrl = productUrl.replace(/[%]/g, "");
    //     return productUrl;
    // },
    // priceFormatter: (price) => {
    //     let priceAmt = price.replace('CAD$', '');
    //     let formatedPrice = price.replace(priceAmt, `<span class="price-format">${priceAmt}</span>`);
    //     let finalPrice = formatedPrice.replace('CAD$', '<span class="currency-format">CAD$</span>');
    //     return finalPrice;
    // },
    // imageCheck: (imageUrl, fallBackImgUrl) => {
    //     let postUrl = `${window.location.protocol}//${window.location.hostname}/${imageUrl}`;
    //     let fallBackUrl = `${window.location.protocol}//${window.location.hostname}${fallBackImgUrl}`;
    //     fetch(postUrl, { method: 'HEAD' })
    //         .then(res => {
    //             if (res.ok) {
    //                 return imageUrl;
    //             } else {
    //                 return fallBackImgUrl;
    //             }
    //         }).catch(err => {
    //             console.log('Error:', err);
    //             return fallBackImgUrl;
    //         });
    // },
    // stripHTML(strInputCode) {
    //     return strInputCode.replace(/<\/?[^>]+(>|$)/g, "");
    // },
    // encodeUrlBasedValue: (str) => {
    //     return encodeUrlBasedValue(str);
    // },
    // decodeUrlBasedValue: (str) => {
    //     return decodeUrlBasedValue(str);
    // },

    customFetch: (actionUrl, isMultiPart, beginType, successType, failureType, dispatch) => {
        // let browserTimeZone = momentTimeZone.tz.guess();
        // if(browserTimeZone){
        //     if(isMultiPart){
        //       formData.append('browserTimeZone', browserTimeZone);          
        //     }else{
        //         formData=formData+'&browserTimeZone='+browserTimeZone;
        //     }
        // }
        var data = {
            credentials: 'include',
            method: 'Get',
            redirect: 'follow',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            // body: formData
        }
        if (isMultiPart) {
            data = {
                credentials: 'include',
                method: 'Get',
                enctype: 'multipart/form-data',
                contentType: false,
                processData: false,
                body: formData
            }
        }
        dispatch({
            type: beginType,
        })

        //currently commenting below postURL, because now we are getting hostname via preloadstate and constructing the url
        // var postURL = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`;
        var postURL = actionUrl;
        fetch(postURL, data)
            .then(res => {
                if (res.redirected) {
                    var url = res.url
                    var pathname = new URL(url).pathname
                    // var fullpath=`${window.location.protocol}//${window.location.hostname}${pathname}`
                    // if(window.location.port){
                    // var fullpath=`${window.location.protocol}//${window.location.hostname}:${window.location.port}${pathname}`
                    // }

                    if (pathname.startsWith('//')) {
                        pathname = pathname.replace('//', '/')
                    }
                    window.location.href = `${pathname}`
                } else {
                    res.json().then(res => {
                        dispatch({
                            type: successType,
                            payload: res
                        })
                    })
                }
            })
            .catch(error => {
                dispatch({
                    type: failureType,
                    payload: error
                })
                throw error
            })
    },

    customFetchApi: (actionUrl, formData, isMultiPart, beginType, successType, failureType, dispatch) => {
        let browserTimeZone = momentTimeZone.tz.guess();
        if (browserTimeZone) {
            if (isMultiPart) {
                formData.append('browserTimeZone', browserTimeZone);
            } else {
                formData = formData + '&browserTimeZone=' + browserTimeZone;
            }
        }
        var data = {
            credentials: 'include',
            method: 'POST',
            redirect: 'follow',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formData
        }
        if (isMultiPart) {
            data = {
                credentials: 'include',
                method: "POST",
                enctype: 'multipart/form-data',
                contentType: false,
                processData: false,
                body: formData
            }
        }
        dispatch({
            type: beginType,
        })

        //currently commenting below postURL, because now we are getting hostname via preloadstate and constructing the url
        // var postURL = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`;
        var postURL = actionUrl;
        fetch(postURL, data)
            .then(res => {
                if (res.redirected) {
                    var url = res.url
                    var pathname = new URL(url).pathname
                    // var fullpath=`${window.location.protocol}//${window.location.hostname}${pathname}`
                    // if(window.location.port){
                    // var fullpath=`${window.location.protocol}//${window.location.hostname}:${window.location.port}${pathname}`
                    // }

                    if (pathname.startsWith('//')) {
                        pathname = pathname.replace('//', '/')
                    }
                    window.location.href = `${pathname}`
                } else {
                    res.json().then(res => {
                        dispatch({
                            type: successType,
                            payload: res
                        })
                    })
                }
            })
            .catch(error => {
                dispatch({
                    type: failureType,
                    payload: error
                })
                throw error
            })
    },

    fetchCallFunction: async (url, method, isMultiPart, contentType, formData) => {
        var response = await asyncFetchCall(url, method, isMultiPart, contentType, formData)
        return response;
    },

    getOrderSummary: async (body) => {
        var actionUrl = "api/rest/cb/checkout/get-order-summary"
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await asyncFetchCall(Url, "POST", false, APPLICATION_JSON, JSON.stringify(body))
        if (res.result === "success") {
            return JSON.parse(res.response).response;
        }
        else {
            console.log("error--", res.response);
            return res.response;
        }
    },
    phoneNumberFormatter: (phoneNumber) => {
        if (phoneNumber != null || phoneNumber.length != 0) {
            const formatted = phoneNumber.replace(/(\d{3})(\d{3})?(\d{0,4})?/, (match, p1, p2, p3) => {
                let result = p1;
                if (p2) result += `-${p2}`;
                if (p3) result += `-${p3}`;
                return result;
            });
            return formatted;
        }
    },
    dateFormatter: (date) => {
        var formattedDate = ""
        if (date != "" || date != null) {
            var dateObject = new Date(date);
            var day = dateObject && dateObject.getDate();
            var month = dateObject && dateObject.getMonth() + 1;
            var year = dateObject && dateObject.getFullYear();
            day = day < 10 ? '0' + day : day;
            month = month < 10 ? '0' + month : month;
            formattedDate = month + '/' + day + '/' + year;
        }
        return formattedDate;
    },
    blogDateFormatter: (date) => {
        //this helper method will format & return the date like october 10, 2024
        var formattedDate = ""
        if (date != "" || date != null) {
            const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
            var dateObject = new Date(date);
            var day = dateObject && dateObject.getDate();
            var month = dateObject && dateObject.getMonth() + 1;
            var year = dateObject && dateObject.getFullYear();
            day = day < 10 ? '0' + day : day;
            month = months[month];
            formattedDate = month + ' ' + day + ', ' + year;
        }
        return formattedDate;
    },
    labelMerger: (label) => {
        var mergedLabel = "";
        if (label.length != 0) {
            var splitedLabel = label.split(" ");

            if (splitedLabel) {
                splitedLabel.map((oneLabel) => {
                    if (splitedLabel.indexOf(oneLabel) != 0) {
                        if (oneLabel) {
                            let firstLetterUpperCase = oneLabel[0].toUpperCase();
                            let labelSubStr = oneLabel.substr(1, oneLabel.length - 1);
                            oneLabel = firstLetterUpperCase + labelSubStr;
                        }
                    }

                    mergedLabel += oneLabel;
                })
            }
        }
        return mergedLabel;
    },
    isValidZipcodeUS : (zipCode)=>{
        var zipCodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/
        if(zipCode != "" || zipCode.length != 0 || zipCode != null){
            console.log("isValidZipcodeUS if", zipCodeRegex.test(zipCode));
            return zipCodeRegex.test(zipCode);
        }else{
            console.log("isValidZipcodeUS else", zipCodeRegex.test(zipCode));
            return false;
        }
    },
}

async function asyncFetchCall(url, method, isMultiPart, contentType, formData) {
    var responseData = "";
    var data = "";
    if (method == "GET") {
        data = {
            credentials: 'include',
            method: method,
        }
    } else {
        if (isMultiPart) {
            data = {
                credentials: 'include',
                method: 'POST',
                enctype: 'multipart/form-data',
                body: formData
            }
        } else {
            data = {
                credentials: 'include',
                method: 'POST',
                headers: new Headers({
                    "content-Type": contentType,
                }),
                body: formData
            }
        }
    }
    await fetch(url, data)
        .then((res) => res.json())
        .then((res) => {
            responseData = res
        });
    return responseData;
}

// async function getformattedCurrency(){
//     const currencyFormatter = await fetch(`${window.location.protocol}//${window.location.hostname}/get-currency?amount=${currency}`)
//     .then(response => {
//         return response.json();
//     }).then(result => {
//         console.log("getCurrency"+result);
//         console.log("getCurrency"+result.cartQty);
//         return Promise.resolve(result.formattedAmount);
//     });
// }
// function checkEmpty(value) {
//     return (/(null|undefined|^$|\s|^\d+$)/).test(value)
// }
// function handleValidation(event) {
//     var elmName = event.target.getAttribute('name');
//     var parentElm = event.target.parentElement;
//     var value = event.target.value;
//     var isRequired = event.target.getAttribute('data-validation-required');
//     var errorMsg = event.target.getAttribute('data-error-msg');
//     var regexErrorMsg = event.target.getAttribute('data-regexError-msg');
//     var regex = RegExp(event.target.getAttribute('data-validation-regex'));
//     if (isRequired && checkEmpty(value)) {
//         if (elmName) {
//             let node = parentElm.nodeName;
//             parentElm.innerHTML += `<p class="error_message error mb-3">${errorMsg}</p>`;
//         }
//     } else if (!(regex).test(value)) {
//         if (elmName) {
//             parentElm.innerHTML += `<p class="error_message error mb-3">${regexErrorMsg}</p>`;
//         }
//     } else {
//         if (parentElm.contains(document.querySelector(`.${parentElm.className} .error`))) {
//             document.querySelector(`.${parentElm.className} .error`).remove();
//         }
//     }
// }
function serialize(form) {
    if (!form || form.nodeName !== "FORM") {
        return;
    }
    var i, j, q = [];
    for (i = form.elements.length - 1; i >= 0; i = i - 1) {
        if (form.elements[i].name === "") {
            continue;
        }
        switch (form.elements[i].nodeName) {
            case 'INPUT':
                switch (form.elements[i].type) {
                    case 'text':

                    case 'tel':
                    case 'email':
                    case 'hidden':
                    case 'password':
                    case 'button':
                    case 'reset':
                    case 'submit':
                        q.push(form.elements[i].name + "=" + (encodeURIComponent(form.elements[i].value)));
                        break;
                    case 'checkbox':
                    case 'radio':
                        if (form.elements[i].checked) {
                            q.push(form.elements[i].name + "=" + (form.elements[i].value));
                        }
                        break;
                }
                break;
            case 'file':
                break;
            case 'TEXTAREA':
                q.push(form.elements[i].name + "=" + (encodeURIComponent(form.elements[i].value)));
                break;
            case 'SELECT':
                switch (form.elements[i].type) {
                    case 'select-one':
                        q.push(form.elements[i].name + "=" + (form.elements[i].value));
                        break;
                    case 'select-multiple':
                        for (j = form.elements[i].options.length - 1; j >= 0; j = j - 1) {
                            if (form.elements[i].options[j].selected) {
                                q.push(form.elements[i].name + "=" + (form.elements[i].options[j].value));
                            }
                        }
                        break;
                }
                break;
            case 'BUTTON':
                switch (form.elements[i].type) {
                    case 'reset':
                    case 'submit':
                    case 'button':
                        q.push(form.elements[i].name + "=" + (form.elements[i].value));
                        break;
                }
                break;
        }
    }


    return q.join("&");
}


const isEmpty = (value) => {
    if (value == null || value.length == 0) {
        return true
    } else {
        return false
    }
}

